import { WrenchTheme } from '@wds/styles';
import { HeaderTheme } from '../theme';

const WrenchHeaderTheme: HeaderTheme = {
  background: {
    main: WrenchTheme.palette.primary.main,
  },
  text: {
    main: WrenchTheme.palette.text.light,
  },
  height: 48,

  breakpoints: WrenchTheme.breakpoints,
  palette: WrenchTheme.palette,
  radius: WrenchTheme.radius,
  spacing: WrenchTheme.spacing,
  type: WrenchTheme.type,
};

export { WrenchHeaderTheme };
export default WrenchHeaderTheme;
